<nz-space nzDirection="vertical" style="width: 100%;">
  <nz-space-item>
    <button nz-button (click)="loadData();" [disabled]="isLoading" style="float: right;">
      <i nz-icon nzType="reload" nzTheme="outline"></i> {{'Refresh'|locale}}
    </button>
  </nz-space-item>
  <nz-space-item>
    <nz-skeleton *ngIf="isLoading">
    </nz-skeleton>
    <app-table-section *ngIf="!isLoading" [tableCols]="section.ColumnSettingsParsed" [dataset]="dataTable.dataset"
      [tableName]="dataTable.name" [cellSettings]="[]" [displayFooter]="true" [isTableLoading]="isTableLoading">
    </app-table-section>
  </nz-space-item>
</nz-space>
